import { useEffect, useRef, useState } from "react";
import DeletePlantModal from "Components/DeletePlantModal";
import TrashIcon from "Assets/TrashIcon";
import { getPlantDisplayName } from "Helpers/PlantName";
import { usePlantStore } from "Store/PlantStore";
import { useVarietyStore } from "Store/VarietyStore";

const PlantCard = ({
  plantId,
  multiSelectMode,
  setSelectedPlants,
  selectedPlants,
}: {
  plantId: string;
  multiSelectMode: boolean;
  setSelectedPlants: React.Dispatch<React.SetStateAction<string[]>>;
  selectedPlants: string[];
}) => {
  const plant = usePlantStore((state) =>
    state.plants.find((item) => item._id === plantId),
  );
  const fetchVarieties = useVarietyStore((state) => state.fetchVarieties);
  const varieties = useVarietyStore((state) => state.varieties);
  const openPlantModal = usePlantStore((state) => state.openPlantModal);
  const [displayDeleteButton, setDisplayDeleteButton] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const elementRef = useRef<HTMLDivElement>(null);
  const [width, setWidth] = useState(0);

  useEffect(() => {
    const observer = new ResizeObserver(() => {
      if (elementRef.current) {
        setWidth(elementRef.current.clientWidth);
      }
    });

    if (elementRef.current) {
      observer.observe(elementRef.current);
    }

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    void fetchVarieties();
  }, [fetchVarieties]);

  const marginLeft = () => (width ? `${width}px` : "0px");

  if (!plant) return null;

  return (
    <div>
      <div
        onClick={() => {
          if (!multiSelectMode) {
            openPlantModal(plantId);
          } else {
            const newPlants = selectedPlants.includes(plantId)
              ? selectedPlants.filter((id) => id !== plantId)
              : [...selectedPlants, plantId];

            setSelectedPlants(newPlants);
          }
        }}
        onMouseEnter={() => setDisplayDeleteButton(true)}
        onMouseLeave={() => setDisplayDeleteButton(false)}
        className="max-w-[16em] flex-grow overflow-hidden shadow-lg rounded flex-wrap p-5 m-5 bg-lightgreen cursor-pointer"
      >
        {displayDeleteButton && !multiSelectMode && (
          <button
            onClick={(event) => {
              event.stopPropagation();
              setShowDeleteModal(true);
              setDisplayDeleteButton(false);
            }}
            className="btn p-15 text-[red] bg-[red] circle absolute mt-[-70px]"
            style={{ marginLeft: marginLeft() }}
          >
            <TrashIcon />
          </button>
        )}
        <div className="flex">
          {multiSelectMode && (
            <input
              type="checkbox"
              className="mr-2 w-[40px]"
              checked={selectedPlants.includes(plantId)}
              onClick={() => {
                const newPlants = selectedPlants.includes(plantId)
                  ? selectedPlants.filter((id) => id !== plantId)
                  : [...selectedPlants, plantId];

                setSelectedPlants(newPlants);
              }}
            />
          )}
          <h2 className="text-lg">{getPlantDisplayName(plant, varieties)}</h2>
        </div>
      </div>

      {showDeleteModal && (
        <DeletePlantModal
          setShowDeleteModal={setShowDeleteModal}
          showDeleteModal={showDeleteModal}
          plantId={plantId}
        />
      )}
    </div>
  );
};

export default PlantCard;
